import { takeLatest, call, put } from 'redux-saga/effects'

import { errorHandler } from '../../core/helpers/errorHelpers'
import { fetchTalentAdvisorEntitySaga } from '../../core/sagas/talentAdvisors'
import { fetchCodingTestEntitySaga } from '../../core/sagas/codingTests'
import * as statusInfoView from '../reducks/statusInfo'

function* fetchTalentAdvisorSaga({ meta }) {
  try {
    const response = yield call(fetchTalentAdvisorEntitySaga, meta.id)
    yield put(statusInfoView.fetchTalentAdvisorSuccess(response.result))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(statusInfoView.fetchTalentAdvisorError(error))
  }
}

function* fetchCodingTestSaga({ meta }) {
  try {
    const response = yield call(fetchCodingTestEntitySaga, meta.id)
    yield put(statusInfoView.fetchCodingTestSuccess(response.result))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(statusInfoView.fetchCodingTestError(error))
  }
}

export default function* watchStatusInfoSaga() {
  yield takeLatest(statusInfoView.FETCH_TALENT_ADVISOR, fetchTalentAdvisorSaga)
  yield takeLatest(statusInfoView.FETCH_CODING_TEST, fetchCodingTestSaga)
}
